export default __webpack_public_path__ + "static/media/gabriel.a6d3e6fe.jpg";